import { h, Fragment, cn, type VNode, renderToString } from '../../../lib/vdom.js';
import * as I from './Icon.jsx';

import type { ImageData } from './ImageCarousel.jsx';

export default function ImageDialog() {
  return (
    <dialog id="image-dialog">
      <button className="close">
        <I.IconX />
      </button>
      <button className="next">
        <I.IconChevronRight />
      </button>
      <button className="prev">
        <I.IconChevronLeft />
      </button>
      <img className="main-image" />
      <div className="caption"></div>
    </dialog>
  );
}

export function openImageDialog(images: ImageData[], initIndex: number) {
  const dialog = document.getElementById('image-dialog') as HTMLDialogElement;
  if (dialog.open) throw new Error('Image dialog already open'); // makes setting up events handlers easier

  (dialog.querySelector('button.close') as HTMLButtonElement).onclick = close;
  (dialog.querySelector('button.next') as HTMLButtonElement).onclick = goToNext;
  (dialog.querySelector('button.prev') as HTMLButtonElement).onclick = goToPrev;
  dialog.onkeydown = keyDown;
  dialog.onclick = dialogClicked;
  let index = initIndex;
  setImage(index);
  dialog.showModal();

  function setImage(i: number) {
    index = i;
    const image = images[index];
    (dialog.querySelector('img.main-image') as HTMLImageElement).src = image.src;
    (dialog.querySelector('.caption') as HTMLElement).innerHTML = renderToString(image.caption);
  }

  function goToNext() {
    setImage((index + 1) % images.length);
  }

  function goToPrev() {
    setImage((index - 1 + images.length) % images.length);
  }

  function keyDown(e: KeyboardEvent) {
    if (e.key === 'ArrowRight' || (e.key === ' ' && !e.shiftKey)) {
      goToNext();
    } else if (e.key === 'ArrowLeft' || (e.key === ' ' && e.shiftKey)) {
      goToPrev();
    } else {
      return;
    }

    // Prevents space key from closing dialog because after opening the dialog
    // it is automatically focused.
    e.preventDefault();
    e.stopPropagation();
  }

  function dialogClicked(e: MouseEvent) {
    if (e.target === dialog) close();
  }

  function close() {
    dialog.close();
  }
}
